export enum EActions {
    initialization = '@unifiedAddressForm/initialization',
    initialized = '@unifiedAddressForm/initialized',

    setAddress = '@unifiedAddressForm/address/set',
    selectAddressFromList = '@unifiedAddressForm/address/selectFromList',

    startChecking = '@unifiedAddressForm/checking/start',
    checkingFinish = '@unifiedAddressForm/checking/finished',

    setCheckingResult = '@unifiedAddressForm/checking/setResult',

    submit = '@unifiedAddressForm/submit',

    flush = '@unifiedAddressForm/flush',
}
